import { render } from "./segment.selector.vue?vue&type=template&id=180a7ab5&ts=true"
import script from "./segment.selector.vue?vue&type=script&lang=ts"
export * from "./segment.selector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__